import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@mui/material";
export default function AlbumCardSkeleton() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="min-w-0 flex-1"><Skeleton variant="rectangular" width="100%" height="100%" className="w-full h-full" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex min-h-0 flex-1 gap-1">{t0}<div className="min-w-0 flex-1"><Skeleton variant="rectangular" width="100%" height="100%" className="w-full h-full" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="min-h-0 flex-1"><Skeleton variant="rectangular" width="100%" height="100%" className="w-full h-full" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Skeleton variant="text" width="70%" height={18} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex w-full aspect-square flex-col overflow-hidden rounded-lg"><div className="flex h-full min-h-0 flex-1 flex-col gap-1 border-4 border-[--colorDisabledOnColorDisabled] rounded-lg overflow-hidden ">{t1}<div className="flex min-h-0 flex-1 gap-1 relative ">{t2}<div className=" flex flex-col  justify-end absolute bottom-0 left-0 w-full h-full bg-gradient-to-t from-[#5e5e5e] via-[#5e5e5e50] to-transparent p-2 ">{t3}<div className="flex gap-2"><Skeleton variant="text" width="44%" height={16} /><Skeleton variant="text" width="20%" height={16} /></div></div></div></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}